import * as React from "react";
import { FormEvent, useEffect, useState } from "react";
import {
  GetSurveyResponses,
  ISurveySequence,
  SkipLogicType,
  SurveyRespond, SurveyRespondQuestion,
  TApiAnswerEntity,
  TApiQuestionEntity,
  TSurveysState,
} from '../../../types/Survey';
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  getAnswer,
  getAnswerComment,
  getCategory,
  getQuestion,
} from "../../../helpers/Survey";
import { IAppState } from "../../../store/Store";
import { compose } from "redux";
import { withSurveyData } from "../../../components/hoc/requiresSurveyData";
import { routes } from "../../../Routes";
import { reverse } from "named-urls";
import {
  getSurvey,
  getSurveyStructure,
  surveyRespond,
  surveyRespondQuestion,
} from '../../../actions/SurveyActions';
import { TDispatch } from "../../../types/Thunk";
import AlertBlock from "../../../components/AlertBlock";
import { useApp } from "../../../hooks/useApp";
import Loader from "../../../components/Loader";
import { find, findIndex, isEmpty, throttle } from "lodash";
import { setCurrentPageTitle } from "../../../actions/ContentActions";
import AnswerCommentModal from "../../../components/modals/AnswerCommentModal";
import Question from "../../../components/survey/Question";
import QuestionOpenEnded from "../../../components/survey/QuestionOpenEnded";
import {
  loadStoredRespondentState,
  useSkipLogic,
  useSurveyNavigation,
} from "../../../hooks/useCurrentActiveSurvey";
import { SurveyInspectionType } from "../../../types/Content";
import {
  setInspectionPhotoSent,
  setInspectionQuestion, setInspectionQuestionId,
  setInspectionSent,
  setInspectionTaskSent,
} from '../../../actions/InspectionActions';
import { useInspection } from "../../../hooks/useInspection";
import SurveyTranslation from '../../../components/survey/SurveyTranslation';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useContentState } from '../../../hooks/useСontentState';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryNavbar: {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      display: "flex",
      alignItems: "stretch",
      padding: theme.spacing(1, 2),
      minHeight: 56,
      marginBottom: theme.spacing(2),
      borderRadius: "8px",
    },
    navButton: {
      color: "#000",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textTransform: "none",
      minWidth: 80,
      "& .MuiButton-label": {
        flexDirection: "column",
      },
    },
    exitButton: {
      marginLeft: "auto",
      color: "#000",
      minWidth: 80,
      "& .MuiButton-label": {
        flexDirection: "column",
      },
    },
    icon: {
      fontSize: 28,
      marginBottom: theme.spacing(0.5),
    },
  })
);

const SurveyQuestionPage: React.FC<RouteComponentProps<any>> = (
  props
): JSX.Element => {
  const classes = useStyles({});
  const [selectedAnswer, setSelectedAnswer] = useState<any>(null);
  const { t } = useTranslation();
  const dispatch = useDispatch<TDispatch>();
  const respondentIdentifier = loadStoredRespondentState();
  const surveysState: TSurveysState = useSelector<IAppState, TSurveysState>(
    (state) => state.surveysState
  );
  const [question, setQuestion] = useState<TApiQuestionEntity | undefined>(
    undefined
  );
  const [nextQuestion, setNextQuestion] = useState<
    TApiQuestionEntity | undefined
  >(undefined);
  const [nextCategory, setNextCategory] = useState<ISurveySequence | undefined>(
    undefined
  );
  const { isInspectionStored, isInspectionSent, inspectionQustionId, isInspectionPhotoSent, isInspectionTaskSent } = useInspection();
  const [nextSubCategory, setNextSubCategory] = useState<
    ISurveySequence | undefined
  >(undefined);
  const [showCommentBlock, setShowCommentBlock] = useState(false);
  const [showSuccessReporting, setShowSuccessReporting] = useState(false);
  const [showSuccessPhoto, setShowSuccessPhoto] = useState(false);
  const [showSuccessTask, setShowSuccessTask] = useState(false);
  const [openEndedAnswerMissing, setOpenEndedAnswerMissing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState("");
  const { isCasePagePublished } = useContentState();
  const [isExitDialogOpen, setIsExitDialogOpen] = useState(false);
  const { app } = useApp();
  const { findSkipLogic, getQuestionParentInfo, getCategoryParentId } =
    useSkipLogic();

  const { goToQuestion, goToCategory, goToFinishSurveyPage } =
    useSurveyNavigation(props.history);

  const surveyId: number = parseInt(props.match.params.id);
  const currentCategoryId: number = parseInt(props.match.params.categoryId);
  const currentSubcategoryId: number | null = props.match.params.subCategoryId
    ? parseInt(props.match.params.subCategoryId)
    : null;
  const currentQuestionId: number | null = props.match.params.questionId
    ? parseInt(props.match.params.questionId)
    : null;

  useEffect(() => {
    if (!surveysState.currentSurvey && !surveysState.loading) {
      if (!respondentIdentifier) {
        throw new Error(`No stored respondent`);
      }

      (async () => {
        await dispatch(
          getSurvey(
            surveyId,
            respondentIdentifier.lang,
            respondentIdentifier.invitationId,
            respondentIdentifier.preview
          )
        );
        await dispatch(getSurveyStructure(surveyId, respondentIdentifier.lang));
      })();
    }
  },
    [
      dispatch,
      surveyId,
      surveysState.currentSurvey,
      surveysState.loading,
      respondentIdentifier
    ]);

  useEffect(() => {
    setLoading(false);
    //If inspection was stored - we should display success reporting notification and clear stored inspection
    if (isInspectionStored) {
      if (isInspectionPhotoSent) {
        setShowSuccessPhoto(true);
        dispatch(setInspectionPhotoSent(false));
      }
      if (isInspectionSent) {
        setShowSuccessReporting(true);
        dispatch(setInspectionSent(false));
      }
      if (isInspectionTaskSent) {
        setShowSuccessTask(true);
        dispatch(setInspectionTaskSent(false));
      }
      if (inspectionQustionId > 0) {
        dispatch(setInspectionQuestionId(0));
      }

      dispatch(setInspectionQuestion(false));
    }
  }, [isInspectionStored, isInspectionSent, inspectionQustionId, isInspectionPhotoSent, isInspectionTaskSent, dispatch]);

  const redirectToNextStep = () => {
    const nextCategoryId = nextSubCategory
      ? currentCategoryId
      : nextCategory?.data?.id;
    const nextSubCat = nextSubCategory?.data?.id || null;
    const currentCategory = getCategory(
      surveysState.surveySequence,
      currentCategoryId
    );

    if (
      surveysState.currentSurvey?.survey.comments &&
      nextCategoryId !== currentCategoryId
    ) {
      //Survey has comments enabled
      props.history.push({
        pathname: reverse(routes.surveyCategoryComment, {
          id: surveyId,
          categoryId: currentCategoryId,
        }),
        state: {
          nextCategory: nextCategoryId,
          nextSubCategory: nextSubCat,
          comments: surveysState.currentSurvey?.survey.comments,
          categoryName: currentCategory?.data.title,
        },
      });
    } else {
      if (nextCategoryId) {
        goToCategory(surveyId, nextCategoryId, nextSubCat);
      } else {
        goToFinishSurveyPage(surveyId);
      }
    }
  };

  useEffect(() => {
    if (!respondentIdentifier) {
      throw new Error(`No stored respondent`);
    }

    if (surveysState.questionsList && currentQuestionId) {
      const showCounter =
        surveysState.currentSurvey?.survey.showQuestionCounter !== false;
      const customHeader =
        typeof surveysState.currentSurvey?.survey.questionHeader === "string"
          ? surveysState.currentSurvey?.survey.questionHeader
          : null;

      if (showCounter) {
        const totalQuestions = surveysState.questionsList.length;
        const currentQuestion = findIndex(
          surveysState?.questionsList,
          (d) => d === currentQuestionId
        );
        dispatch(
          setCurrentPageTitle(
            `${
              customHeader !== null
                ? customHeader
                : t("survey.question.count.prefix", {
                    lng: respondentIdentifier.lang,
                  })
            } ${currentQuestion + 1} / ${totalQuestions}`
          )
        );
      } else {
        dispatch(setCurrentPageTitle(customHeader ?? ""));
      }
    }
    // eslint-disable-next-line
  }, [currentQuestionId, surveysState.questionsList, surveysState.currentSurvey, props.location.pathname]);

  useEffect(() => {
    if (surveysState.responses && currentQuestionId) {
      const currentQuestionComment = getAnswerComment(
        surveysState.responses.answers,
        currentQuestionId
      );
      setComment(currentQuestionComment ?? "");
      setSelectedAnswer({
        ...selectedAnswer,
        answerComment: comment,
        id: getAnswer(surveysState.responses.answers, currentQuestionId),
      });
    }
    // eslint-disable-next-line
  }, [currentQuestionId, surveysState.responses]);

  const redirectToNextQuestion = (storeQuestion: boolean) => {
    setComment("");
    setShowSuccessReporting(false);
    setShowSuccessPhoto(false);
    setShowSuccessTask(false);
    setOpenEndedAnswerMissing(false);
    if (storeQuestion) {
      const respondentIdentifier = loadStoredRespondentState();
      if (!respondentIdentifier) {
        throw new Error(`No stored respondent`);
      }
      const respondentId = respondentIdentifier.id;

      const questionId = question?.id as number;
      const skipped = true;

      dispatch(
        surveyRespondQuestion({
          respondentId,
          questionId,
          skipped,
        })
      );
    }

    if (nextQuestion) {
      goToQuestion(
        surveyId,
        currentCategoryId,
        nextQuestion?.id,
        currentSubcategoryId
      );
    } else {
      redirectToNextStep();
    }
  };

  const setQuestions = (questions: Array<TApiQuestionEntity>) => {
    setQuestion(getQuestion(questions, currentQuestionId));
    setNextQuestion(getQuestion(questions, currentQuestionId, true));
  };

  // eslint-disable-next-line
  useEffect(() => {
    const currentCategory = getCategory(
      surveysState.surveySequence,
      currentCategoryId
    );
    const leaveCurrentCategory =
      (!currentSubcategoryId && !isEmpty(currentCategory?.subCategories)) ||
      !!nextSubCategory;
    if (currentCategory) {
      setNextCategory(
        getCategory(
          surveysState.surveySequence,
          currentCategoryId,
          !leaveCurrentCategory
        )
      );
    }
    if (!currentSubcategoryId) {
      if (currentCategory?.questions) {
        setQuestions(currentCategory.questions);
      }
      if (currentCategory?.subCategories) {
        setNextSubCategory(
          getCategory(currentCategory.subCategories, currentSubcategoryId, true)
        );
      }
    } else {
      if (currentCategory?.subCategories) {
        const subCategory = getCategory(
          currentCategory.subCategories,
          currentSubcategoryId
        );
        setNextSubCategory(
          getCategory(currentCategory.subCategories, currentSubcategoryId, true)
        );
        if (subCategory?.questions) {
          setQuestions(subCategory.questions);
        }
      }
    }
  });

  const submitAnswerCommentForm = (e: FormEvent, answerId: number) => {
    e.preventDefault();
    const answerData = find(
      question?.answers,
      (a) => a.id === answerId
    ) as TApiAnswerEntity;
    if (answerData) {
      return performRespond(answerData);
    }

    return false;
  };

  const performRespond = (answer: TApiAnswerEntity) => {
    setShowCommentBlock(false);
    const respondentIdentifier = loadStoredRespondentState();
    if (!respondentIdentifier) {
      throw new Error(`No stored respondent`);
    }
    const respondentId = respondentIdentifier.id;

    const questionId = question?.id as number;
    const answerId = answer.id;

    dispatch(
      surveyRespond({
        respondentId,
        questionId,
        answerId,
        comment: question?.isOpenEnded || answer.allowComment ? comment : "",
      })
    ).then(() => {
      setComment("");

      const questionSkipLogic = findSkipLogic(questionId, answerId);

      if (questionSkipLogic) {
        setShowSuccessReporting(false);
        setShowSuccessPhoto(false);

        switch (questionSkipLogic.type) {
          case SkipLogicType.JUMP_TO_QUESTION:
            const newQuestionId = questionSkipLogic.targetId as number;
            const parentInfo = getQuestionParentInfo(newQuestionId);
            if (parentInfo) {
              goToQuestion(
                surveyId,
                parentInfo.categoryId,
                newQuestionId,
                parentInfo.subcategoryId as number
              );
              return;
            }

            break;
          case SkipLogicType.JUMP_TO_CATEGORY:
            const newCategoryId = questionSkipLogic.targetId as number;
            const parentCategoryId = getCategoryParentId(newCategoryId);

            goToCategory(
              surveyId,
              parentCategoryId ? parentCategoryId : newCategoryId,
              parentCategoryId ? newCategoryId : 0
            );
            return;

          case SkipLogicType.END_SURVEY:
            goToFinishSurveyPage(surveyId);
            return;
        }
      }

      //Below is normal flow
      redirectToNextQuestion(false);
    });
  };

  if (!question || loading || app.isLoading(GetSurveyResponses)) {
    return <Loader visible={true} />;
  }

  const handleAnswerSubmit = (answerId: number) => {
    if (selectedAnswer && selectedAnswer.id !== answerId) {
      setComment("");
    }
    const answerData = find(
      question?.answers,
      (a) => a.id === answerId
    ) as TApiAnswerEntity;
    setSelectedAnswer(answerData);
    if (answerData.allowComment) {
      if (!app.isLoading(SurveyRespondQuestion)) {
        const respondentIdentifier = loadStoredRespondentState();
        if (!respondentIdentifier) {
          throw new Error(`No stored respondent`);
        }
        const respondentId = respondentIdentifier.id;

        const questionId = question?.id as number;
        const skipped = false;

        dispatch(
          surveyRespondQuestion({
            respondentId,
            questionId,
            skipped,
          })
        );
      }

      return setShowCommentBlock(true);
    }

    if (answerData.id && !app.isLoading(SurveyRespond)) {
      return performRespond(answerData as TApiAnswerEntity);
    }

    return false;
  };

  const handleOpenEndedSubmit = () => {
    const answerData = question?.answers?.[0];
    if (!answerData) {
      setOpenEndedAnswerMissing(true);

      return false;
    }

    setOpenEndedAnswerMissing(false);

    if (!app.isLoading(SurveyRespond)) {
      return performRespond(answerData as TApiAnswerEntity);
    }

    return false;
  };

  const handleReportCaseClick = () => {
    dispatch(setInspectionQuestion(true));
    if (currentQuestionId) {
      dispatch(setInspectionQuestionId(currentQuestionId));
    }
    props.history.push(reverse(routes.reportCase));
  };

  const handleCreateTaskClick = () => {
    dispatch(setInspectionQuestion(true));
    if (currentQuestionId) {
      dispatch(setInspectionQuestionId(currentQuestionId));
    }
    props.history.push(reverse(routes.inspectionTaskCreate));
  };

  const handleInspectionPhotoClick = () => {
    dispatch(setInspectionQuestion(true));
    if (currentQuestionId) {
      dispatch(setInspectionQuestionId(currentQuestionId));
    }
    props.history.push(reverse(routes.inspectionImage));
  };

  const handleOpenExitDialog = () => {
    setIsExitDialogOpen(true);
  };

  const handleCloseExitDialog = () => {
    setIsExitDialogOpen(false);
  };

  const handleConfirmExit = () => {
    handleCloseExitDialog();
    props.history.push(reverse(routes.inspectionList));
  };

  return (
    <>

      {surveysState.currentSurvey?.survey.surveyType === SurveyInspectionType.INSPECTION && (
        <>
          <Box className={classes.secondaryNavbar}>
            {isCasePagePublished && surveysState.currentSurvey?.survey?.allowCases !== false && (
              <Button
                className={classes.navButton}
                onClick={handleReportCaseClick}
              >
                <ErrorOutlineIcon className={classes.icon} />
                <SurveyTranslation translate={"case.report.submit.button"} />
              </Button>
            )}

            {surveysState.currentSurvey?.survey?.allowMedia && (
              <Button
                className={classes.navButton}
                onClick={handleInspectionPhotoClick}
              >
                <CameraAltIcon className={classes.icon} />
                <SurveyTranslation translate={"inspection.media.submit.button"} />
              </Button>
            )}

            {surveysState.currentSurvey?.survey?.allowTasks && (
              <Button
                className={classes.navButton}
                onClick={handleCreateTaskClick}
              >
                <CheckCircleIcon className={classes.icon} />
                <SurveyTranslation translate={"inspection.task.submit.button"} />
              </Button>
            )}

            <Box flexGrow={1} />

            <Button className={classes.exitButton} onClick={handleOpenExitDialog}>
              <CloseIcon className={classes.icon} />
              <SurveyTranslation translate={"inspection.toolbar.exit"} />
            </Button>
          </Box>
          <Dialog
            open={isExitDialogOpen}
            onClose={handleCloseExitDialog}
            aria-labelledby="exit-dialog-title"
            aria-describedby="exit-dialog-description"
          >
            <DialogTitle id="exit-dialog-title">
              <SurveyTranslation translate={"inspection.exit.modal.header"} />
            </DialogTitle>
            <DialogContent>
              <Typography id="exit-dialog-description">
                <SurveyTranslation translate={"inspection.exit.modal.body"} />
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseExitDialog} color="primary">
                <SurveyTranslation translate={'survey.question.help.modal.close'} />
              </Button>

              <Button onClick={handleConfirmExit} color="secondary" autoFocus>
                <SurveyTranslation translate={"inspection.exit.modal.exit_button"} />
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {question && (
        <>
          {surveysState.currentSurvey?.preview && (
            <>
              <AlertBlock hideCloseButton={true} type={"warning"}>
                <SurveyTranslation translate={"survey.preview"} />
              </AlertBlock>
            </>
          )}

          {showSuccessReporting && (
            <AlertBlock
              type={"success"}
              onClose={() => setShowSuccessReporting(false)}
            >
              <SurveyTranslation translate={"case.report.success.alert_long"} />
            </AlertBlock>
          )}
          {showSuccessPhoto && (
            <AlertBlock
              type={"success"}
              onClose={() => setShowSuccessPhoto(false)}
            >
              <SurveyTranslation translate={"inspection.media.submit.form.success"} />
            </AlertBlock>
          )}
          {showSuccessTask && (
            <AlertBlock
              type={"success"}
              onClose={() => setShowSuccessTask(false)}
            >
              <SurveyTranslation translate={"inspection.task.create.success"} />
            </AlertBlock>
          )}
          {app.hasError(SurveyRespond) && (
            <AlertBlock type={"error"}>
              {app.getError(SurveyRespond).message}
            </AlertBlock>
          )}
          {openEndedAnswerMissing && (
            <AlertBlock type={"error"}>
              <SurveyTranslation translate={"generic.error_filling_form"} />
            </AlertBlock>
          )}
          {!question.isOpenEnded && (
            <AnswerCommentModal
              showCommentBlock={showCommentBlock}
              setShowCommentBlock={setShowCommentBlock}
              submitAnswerCommentForm={submitAnswerCommentForm}
              question={question}
              comment={comment}
              setComment={setComment}
              selectedAnswer={selectedAnswer}
              answerCommentHeader={
                typeof surveysState.currentSurvey?.survey
                  .answerCommentHeader === "string"
                  ? surveysState.currentSurvey?.survey.answerCommentHeader
                  : null
              }
              answerCommentBody={
                typeof surveysState.currentSurvey?.survey.answerCommentBody ===
                "string"
                  ? surveysState.currentSurvey?.survey.answerCommentBody
                  : null
              }
              answerCommentLabel={
                typeof surveysState.currentSurvey?.survey.answerCommentLabel ===
                "string"
                  ? surveysState.currentSurvey?.survey.answerCommentLabel
                  : null
              }
              answerCommentSaveButton={
                typeof surveysState.currentSurvey?.survey
                  .answerCommentSaveButton === "string"
                  ? surveysState.currentSurvey?.survey.answerCommentSaveButton
                  : null
              }
            />
          )}

          {question.isOpenEnded ? (
            <QuestionOpenEnded
              question={question}
              value={comment}
              setValue={setComment}
              handleOpenEndedSubmit={handleOpenEndedSubmit}
              redirectToNextQuestion={redirectToNextQuestion}
              questionRequired={
                typeof surveysState.currentSurvey?.survey.questionRequired ===
                "string"
                  ? surveysState.currentSurvey?.survey.questionRequired
                  : null
              }
              questionSkipButton={
                typeof surveysState.currentSurvey?.survey.questionSkipButton ===
                "string"
                  ? surveysState.currentSurvey?.survey.questionSkipButton
                  : null
              }
              questionContinueButton={
                typeof surveysState.currentSurvey?.survey
                  .questionContinueButton === "string"
                  ? surveysState.currentSurvey?.survey.questionContinueButton
                  : null
              }
            />
          ) : (
            <Question
              question={question}
              selectedAnswer={selectedAnswer}
              handleAnswerSubmit={throttle(handleAnswerSubmit, 500)}
              comment={comment}
              redirectToNextQuestion={redirectToNextQuestion}
              questionRequired={
                typeof surveysState.currentSurvey?.survey.questionRequired ===
                "string"
                  ? surveysState.currentSurvey?.survey.questionRequired
                  : null
              }
              questionSkipButton={
                typeof surveysState.currentSurvey?.survey.questionSkipButton ===
                "string"
                  ? surveysState.currentSurvey?.survey.questionSkipButton
                  : null
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default compose(
  withSurveyData,
  withRouter
)(SurveyQuestionPage) as React.FC;
